import React, { useEffect, useState } from "react";
import '../Pages/About.css'
import { FaMapMarkerAlt, FaPhoneAlt, FaClock } from "react-icons/fa";
import { FaShieldAlt, FaCarSide, FaUserCheck } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";

import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

export default function About() {


   React.useEffect(() => {
      AOS.init({ duration: 800, once: false });
    }, []);
  return (
    <>
<Helmet>
  <title>About Sri Rajalakshmi Travels | Trusted Travels in Aruppukottai</title>

  <meta
    name="description"
    content="Sri Rajalakshmi Travels has been providing reliable van & car rental service in Aruppukottai for 10+ years. Professional drivers, safe vehicles & affordable pricing."
  />

  <meta
    name="keywords"
    content="
      about Aruppukottai travels,
      best travels in Aruppukottai,
      trusted travels Aruppukottai,
      van hire Aruppukottai,
      family trip van booking,
      Aruppukottai tourist operator
    "
  />

  <link rel="canonical" href="https://srirajalakshmitravels.in/about" />

  {/* --------------------------------------------------
      JSON-LD #1 — Travel Agency Schema
     -------------------------------------------------- */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN",
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/",
      ],
    })}
  </script>

  {/* --------------------------------------------------
      JSON-LD #2 — Organization Schema
     -------------------------------------------------- */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Sri Rajalakshmi Travels",
      url: "https://srirajalakshmitravels.in/about",
      description:
        "Sri Rajalakshmi Travels is a trusted van and car rental service provider in Aruppukottai with 10+ years of experience.",
      foundingDate: "2015",
      address: {
        "@type": "PostalAddress",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        addressCountry: "IN",
      },
    })}
  </script>

  {/* --------------------------------------------------
      JSON-LD #3 — Services Schema
     -------------------------------------------------- */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Van Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Car Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Tour Package Booking",
            },
          },
        ],
      },
    })}
  </script>

</Helmet>



    <Navbar/>
    <section className="about-hero-section" id="about-hero">
      <div className="about-hero-container" data-aos="fade-up">

        <h1 className="about-hero-title">
          SRI RAJALAKSHMI <span>TOURS & TRAVELS</span>
        </h1>

        <p className="about-hero-tagline">
          The Most Trusted <strong>Rental Van in Aruppukottai</strong> •
          Premium Cars & Vans for Every Trip • 24/7 Service • 
          <strong>Best Travels in Aruppukottai</strong>
        </p>

        <div className="about-hero-info">

          <div className="hero-info-box">
            <FaMapMarkerAlt className="hero-icon" />
            <p>Aruppukottai – Tamil Nadu</p>
          </div>

          <div className="hero-info-box">
            <FaPhoneAlt className="hero-icon" />
            <p>Call Anytime – 24/7 Support</p>
          </div>

          <div className="hero-info-box">
            <FaClock className="hero-icon" />
            <p>Safe • Comfortable • On-Time Travel</p>
          </div>

        </div>

      </div>
    </section>
    
    

   <section className="why-section" id="why-choose-us">
      <div className="why-container">

        <h2 className="why-title" data-aos="fade-up">
          Why Choose <span>SRI RAJALAKSHMI TRAVELS?</span>
        </h2>

        <p className="why-sub" data-aos="fade-up" data-aos-delay="100">
          The most trusted <strong>Rental Van in Aruppukottai</strong> with 
          24/7 service, professional drivers, and perfectly maintained vehicles.
        </p>

        <div className="why-grid">

          <div className="why-box" data-aos="fade-up" data-aos-delay="150">
            <FaShieldAlt className="why-icon" />
            <h4>Safe & Secure Travel</h4>
            <p>
              100% safety-focused service with experienced drivers and 
              well-maintained vehicles. Best travels in Aruppukottai for family trips.
            </p>
          </div>

          <div className="why-box" data-aos="fade-up" data-aos-delay="200">
            <FaCarSide className="why-icon" />
            <h4>Clean & Premium Vehicles</h4>
            <p>
              All cars & vans are fully serviced, AC-perfect, and ready for any 
              trip — long distance or city travel.
            </p>
          </div>

          <div className="why-box" data-aos="fade-up" data-aos-delay="250">
            <FaUserCheck className="why-icon" />
            <h4>Professional Drivers</h4>
            <p>
              Drivers with great route knowledge, polite behaviour and a 
              commitment to customer comfort.
            </p>
          </div>

          <div className="why-box" data-aos="fade-up" data-aos-delay="300">
            <FaClock className="why-icon" />
            <h4>24/7 Anytime Booking</h4>
            <p>
              Aruppukottai to anywhere in Tamil Nadu — call anytime. 
              Nearby rental van available instantly!
            </p>
          </div>

        </div>

      </div>
    </section>
    










<section id="our-fleet" className="fleet-section">

  <div className="container">

    <h2 className="fleet-title" data-aos="fade-up">
      <span>Our Vehicle Fleet</span> – Premium & Well-Maintained
    </h2>

    <p className="fleet-subtext" data-aos="fade-up">
      We provide <strong>Rental Vans in Aruppukottai</strong>, 
      <strong>Car Rental Services</strong>, and 
      <strong>Tourist Vehicle Hire</strong> for all your travel needs.
    </p>

    <div className="fleet-grid">

      {/* Sedan */}
      <div className="fleet-box" data-aos="fade-up">
        <i className="fleet-icon">🚗</i>
        <h4>Sedan Cars</h4>
        <p>
          Comfortable & budget-friendly. Perfect for family travel and 
          <strong>local taxi service in Aruppukottai</strong>.
        </p>
      </div>

      {/* SUV */}
      <div className="fleet-box" data-aos="fade-up" data-aos-delay="150">
        <i className="fleet-icon">🚙</i>
        <h4>SUV Vehicles</h4>
        <p>
          Spacious & premium. Best for long journeys and hill-station trips.
        </p>
      </div>

      {/* Innova */}
      <div className="fleet-box" data-aos="fade-up" data-aos-delay="300">
        <i className="fleet-icon">🚘</i>
        <h4>Toyota Innova</h4>
        <p>
          Most preferred for comfort and reliability. 
          Ideal for <strong>outstation tours</strong>.
        </p>
      </div>

      {/* Van */}
      <div className="fleet-box" data-aos="fade-up" data-aos-delay="450">
        <i className="fleet-icon">🚌</i>
        <h4>Tourist Vans</h4>
        <p>
          Best <strong>rental van in Aruppukottai</strong> with A/C, comfy seating, 
          and perfect for group travel.
        </p>
      </div>

      {/* Tempo Traveller */}
      <div className="fleet-box" data-aos="fade-up" data-aos-delay="600">
        <i className="fleet-icon">🚐</i>
        <h4>Tempo Traveller</h4>
        <p>
          For big groups. Clean, spacious and ideal for long-distance travel.
        </p>
      </div>

      {/* Mini Bus */}
      <div className="fleet-box" data-aos="fade-up" data-aos-delay="750">
        <i className="fleet-icon">🛻</i>
        <h4>Mini Bus</h4>
        <p>
          Perfect for functions, pilgrimages, school trips and corporate events.
        </p>
      </div>

    </div>

  </div>

</section>

<section id="service-process" className="process-section">

  <div className="container">

    <h2 className="process-title" data-aos="fade-up">
      <span>How Our Travel Service Works</span>
    </h2>

    <p className="process-subtext" data-aos="fade-up">
      Simple 4-step booking process for fast and hassle-free travel.  
      Trusted by thousands for <strong>Rental Vans in Aruppukottai</strong> and  
      <strong>outstation travel services</strong>.
    </p>

    <div className="process-grid">

      {/* Step 1 */}
      <div className="process-box" data-aos="fade-up" data-aos-delay="100">
        <i className="process-icon">📞</i>
        <h4>1. Contact Us</h4>
        <p>
          Call or WhatsApp anytime — 24/7 customer support for all travel enquiries.
        </p>
      </div>

      {/* Step 2 */}
      <div className="process-box" data-aos="fade-up" data-aos-delay="200">
        <i className="process-icon">🚘</i>
        <h4>2. Choose Your Vehicle</h4>
        <p>
          Select from Sedan, SUV, Innova, Rental Vans, Tourist Van,  
          and Tempo Traveller based on your need.
        </p>
      </div>

      {/* Step 3 */}
      <div className="process-box" data-aos="fade-up" data-aos-delay="300">
        <i className="process-icon">📝</i>
        <h4>3. Trip Confirmation</h4>
        <p>
          We confirm your trip with transparent pricing and zero hidden charges.
        </p>
      </div>

      {/* Step 4 */}
      <div className="process-box" data-aos="fade-up" data-aos-delay="400">
        <i className="process-icon">🛣</i>
        <h4>4. Enjoy Your Journey</h4>
        <p>
          Safe driving, clean vehicle, polite drivers —  
          Experience the <strong>best travels service in Aruppukottai</strong>.
        </p>
      </div>

    </div>

  </div>

</section>

<Footer/>
    </>
  )
}
